<template>
  <div class="device-list px">
    <swiper
      class="list"
      :options="options"
      @touchEnd="onSwiper"
      @slideChangeTransitionEnd="onSwiper"
    >
      <swiper-slide
        v-for="(device, index) in deviceList"
        :key="'device_' + index"
      >
        <div
          class="item"
          :class="{
            active: index === activeDeviceIndex,
          }"
          @click="onClick(device, index)"
        >
          <img class="device" :src="images['device_' + device.code]" />
          <div class="name">
            {{ deviceName[device.code] }}
          </div>
          <div class="next">
            <i class="iconfont iconarrow-right" />
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "swiper/swiper-bundle.min.css";

export default {
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("loader", {
      deviceName: "deviceName",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
      activeDeviceIndex: "activeDeviceIndex",
    }),
    options() {
      return {
        initialSlide: this.activeDeviceIndex,
        speed: 400,
        mousewheel: true,
        // spaceBetween: 50,
        effect: "coverflow",
        coverflowEffect: {
          depth: 200, // 深度
          rotate: 0, // 旋转角度
          scale: 1,
          stretch: -150, // 拉伸度
          slideShadows: false, // 是否显示滑动阴影
        },
      };
    },
    deviceList() {
      return this.systemInfo.deviceList;
    },
  },
  methods: {
    onSwiper(swiper) {
      this.$store.dispatch("loader/setActiveDeviceIndex", swiper.activeIndex);
    },
    onClick(device, index) {
      this.$store.dispatch("loader/setActiveDeviceIndex", index);
      this.$store.dispatch("loader/setCurrentDevice", { ...device });
      switch (device.code) {
        case "cyberblade":
          break;
        case "dongle":
          this.$router.replace(this.$paths.dongle);
          break;
        case "mouse":
          this.$router.replace(this.$paths.mouse);
          break;
        case "mousedongle":
          this.$router.replace(this.$paths.dongleMouse);
          break;
        case "magnetkey":
          this.$router.replace(this.$paths.magnetic);
          break;
        default:
          this.$router.replace(this.$paths.firmware);
          break;
      }
    },
  },
  mounted() {
    // if (this.deviceList.length === 0) {
    //   this.$router.replace(this.$paths.welcome);
    // }
  },
};
</script>
<style lang="scss" scoped>
.device-list {
  @include flex-center;
  min-height: inherit;
  color: #ffffff;
  overflow: hidden;

  .list {
    width: 400px;
    height: 670px;
    overflow: visible;

    .item {
      width: 100%;
      height: 100%;
      background: #0d0d0d;
      border: solid 2px transparent;
      border-radius: 30px;
      position: relative;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

      img {
        width: 100%;
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      }

      .name {
        width: 100%;
        text-align: center;
        font-size: 30px;
        margin-top: 450px;
      }

      .next {
        @include flex-center;
        width: 50px;
        height: 50px;
        position: absolute;
        background-image: $linear-gradient;
        border-radius: 100%;
        position: absolute;
        left: 50%;
        bottom: 80px;
        margin-left: -25px;
        opacity: 0;
        transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

        .iconfont {
          margin-left: 6px;
          font-size: 20px;
          line-height: 50px;
          font-weight: bold;
        }
      }

      &.active,
      &:hover,
      &:active,
      &:focus {
        border: solid 2px $primary-color;
        box-shadow: inset 0 0 15px 10px #4136f1;

        img {
          width: 140%;
          max-width: none;
        }

        .next {
          opacity: 1;
        }
      }
    }
  }

  .dongle {
    width: 80px;
    height: 80px;
    line-height: 80px;
    position: fixed;
    right: 30px;
    bottom: 30px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;

    &.active,
    &:hover {
      color: $primary-color;
    }

    .iconfont {
      font-size: 50px;
    }
  }
}
</style>
<style lang="scss">
.device-list {
  .list {
    .swiper-slide-shadow-left,
    .swiper-slide-shadow-right {
      border-radius: 30px;
    }
  }
}
</style>
